module.exports = __webpack_public_path__ + "static/media/xlsx.55d00165.png";